define(function(require,exports,module){
    var priceModel = {
        ajaxGetPrice: function(data, success, error) {
            $.ajax({
                // url:'//p.3.cn/prices/mgets',
                url: '//www.jd.hk/global/getPriceInfo.do',
                data : data,
                method:'get',
                dataType:'jsonp',
                success: function(data) {
                    if($.isFunction(success)) {
                        success(data);
                    }
                }
            });
        },
        getDiscount: function(newPrice, oldPrice) {
            var newPrice = newPrice * 10000;
            var oldPrice = oldPrice * 10000;
            var result = newPrice / oldPrice;

            var discount = Math.ceil(Math.floor( result * 1000) / 10) / 10;
            if (discount > 9.9) {
                discount = "";
            } else if (discount < 0.1) {
                discount = 0.1;
            } else {
                discount = discount.toFixed(1);
                if (discount.substring(discount.length - 1, discount.length) == "0") {
                    discount = discount.substring(0, discount.length - 2);
                }
            }

            return discount;
        },
        formatPrice: function(price) {
            price = price || "";
            var arr = price.split(".");
            if (arr.length == 2) {
                if (arr[1] == "00") {
                    return arr[0];
                } else if (arr[1] == "0000") {
                    return arr[0];
                } else if (arr[1].indexOf("0") == arr[1].length) {
                    return price.substring(0, price.length);
                } else {
                    return price;
                }
            } else {
                return price;
            }
        }
    };
    module.exports = priceModel;
});



// WEBPACK FOOTER //
// ./src/js/model/priceModel/priceModel.js